import React from 'react';
import { useState } from 'react';
import PropTypes from 'prop-types';
import userStore from '../../stores/userStore';
import { getConsumerData } from '../../actions/actionRunner';
import { Container, Grid, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CustomDialog from '../layouts/CustomDialog';
import ErrorMessageDialog from '../layouts/ErrorMessageDialog';
const useStyles = makeStyles(theme => ({
  mainContainer: {
    textAlign: 'center',
    position: 'fixed',
    bottom: 0
  },
  customBg: {
    backgroundColor: '#fafafa'
  },
  refreshButtonContainer: {
    position: "absolute",
    top: 0,
    right: "20vh"
  }
}));
const StatusBarTemplate = props => {
  const classes = useStyles();
  const customStyle = {
    color: props.tokenId ? 'green' : 'red'
  };
  const text = props.tokenId ? 'Consumer with token ' + props.tokenId : '';
  const [isDialogOpen, setOpenDialog] = useState(false);
  const [dialogTitle, setDialogTitle] = useState('');
  const [dialogContent, setDialogContent] = useState('');
  const handleRefreshClick = () => {
    getConsumerData(userStore.getToken()).then(() => {}).catch(function (res) {
      setDialogTitle('Atentie!');
      setDialogContent(() => {
        return /*#__PURE__*/React.createElement(ErrorMessageDialog, {
          message: res.error_message,
          onClick: () => setOpenDialog(false)
        });
      });
      setOpenDialog(true);
    });
  };
  return /*#__PURE__*/React.createElement(Container, {
    className: classes.mainContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.customBg
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 3
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement("p", {
    style: customStyle
  }, text))), /*#__PURE__*/React.createElement("div", {
    className: classes.refreshButtonContainer
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "secondary",
    onClick: handleRefreshClick
  }, "Refresh"))), /*#__PURE__*/React.createElement(CustomDialog, {
    open: isDialogOpen,
    setOpen: setOpenDialog,
    title: dialogTitle
  }, dialogContent));
};
StatusBarTemplate.propTypes = {
  tokenId: PropTypes.string
};
export default StatusBarTemplate;